import { devices } from '@src/styles/theme';
import styled from 'styled-components';
import PageCategory from '@src/components/Molecules/PageCategory';
import CMSelector from '@src/components/Atoms/CMSelector';
import { useRecoilState } from 'recoil';
import filterAtom from '@src/recoils/atom/filter';
import { useCallback } from 'react';
import {
  filterBloodDonationTypeList,
  filterBloodList,
  filterSortList,
} from '@src/data/filter';
import Poster from '@src/components/Organism/Blood-home/Poster';

type Props = {
  isLoading?: boolean;
  isSide?: boolean;
  children: React.ReactNode;
  AsideIsListPage?: boolean;
  AsideDisabledTop?: boolean;
  AsideDisabledBody?: boolean;
  AsideDisabledBottom?: boolean;
  mainText: string;
  href: string;
  postCommunity?: () => void;
  isActive?: boolean;
  /** 우측 Aside(검색·글쓰기·배너)를 숨긴다. 디자인상 사이드바가 없는 페이지에서 사용. */
  hideAside?: boolean;
  /** 디자인의 섹션 최대 폭. 지정하면 컨테이너 폭·좌우 여백을 디자인에 맞춘다. */
  maxWidth?: number;
};

const PageTemplate = ({
  isLoading,
  isSide,
  children,
  AsideIsListPage = true,
  AsideDisabledTop = false,
  AsideDisabledBody = true,
  mainText,
  href,
  postCommunity,
  isActive,
  hideAside = false,
  maxWidth,
}: Props) => {
  const [filter, setFilter] = useRecoilState(filterAtom);
  const filterLabel = (type: string) => {
    const want = filter.filter((e) => e.type === type);
    return want[0].label;
  };
  const onChangefilter = useCallback((label: string, type: string) => {
    const otherList = filter.filter((e) => e.type !== type);
    setFilter([...otherList, { label, type }]);
  }, []);
  return (
    <>
      <Container maxWidth={maxWidth}>
        {hideAside ? (
          // 사이드바 없는 단일 컬럼 (디자인 적용 페이지)
          <>{children}</>
        ) : isSide ? (
          <>
            {!isLoading && (
              <SelectWrap>
                <CMSelector
                  defaultName={filterLabel('abo')}
                  ItemList={filterBloodList}
                  onChangeFilter={onChangefilter}
                />
                <CMSelector
                  defaultName={filterLabel('bloodProduct')}
                  ItemList={filterBloodDonationTypeList}
                  onChangeFilter={onChangefilter}
                />
                <CMSelector
                  defaultName={filterLabel('sortBy')}
                  ItemList={filterSortList}
                  onChangeFilter={onChangefilter}
                />
              </SelectWrap>
            )}
            <Wrap>
              <Flex2>{children}</Flex2>
            </Wrap>
          </>
        ) : (
          <>
            {/* TODO: 페이지에서 카테고리 명 프롭을 주자. */}
            <OnlyViewWrap>
              <OnlyViewList>
                <li>only view</li>
              </OnlyViewList>
            </OnlyViewWrap>
            <Wrap>
              <Flex2>
                <Poster />
                <>{children}</>
              </Flex2>
            </Wrap>
          </>
        )}
      </Container>
    </>
  );
};

const SelectWrap = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0px;
  @media ${devices.tablet} {
    padding: 0px 1.6rem;
  }
`;

const Container = styled.div<{ maxWidth?: number }>`
  max-width: ${({ maxWidth }) => maxWidth ?? 1200}px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  /* 디자인 섹션: padding 32px 20px 0 + 하단 64px */
  ${({ maxWidth }) =>
    maxWidth
      ? `padding: 32px 20px 64px;`
      : ''}
  @media ${devices.tablet} {
    max-width: 100%;
    ${({ maxWidth }) => (maxWidth ? `padding: 20px 16px 48px;` : '')}
  }
`;

const Wrap = styled.section`
  display: flex;
  max-width: 100%;
  @media ${devices.tablet} {
    display: block;
  }
`;

const Flex1 = styled.div`
  flex: 1;
  @media ${devices.tablet} {
    flex: 0;
  }
`;

const Flex2 = styled.div`
  flex: 2;
  @media ${devices.tablet} {
    background-color: #f9f9f9;
  }
`;

const OnlyViewWrap = styled.div`
  display: flex;
  gap: 10px;
  margin: 20px 0px;
  @media ${devices.tablet} {
    display: none;
  }
`;

const OnlyViewList = styled.ul`
  > li {
    visibility: hidden;
    padding: 5px 12px;
  }

  @media ${devices.tablet} {
    display: none;
  }
`;

export default PageTemplate;
